export type Language = 'hr' | 'en'

export const translations = {
  hr: {
    langLabel: 'Hrvatski',
    switchTo: 'Switch to English',
    common: {
      bookConsultation: 'Rezerviraj besplatnu konzultaciju',
      bookAppointment: 'Rezerviraj besplatnu konzultaciju',
      bookNow: 'Rezerviraj besplatnu konzultaciju'
    },
    offer: {
      title: '10% POPUST NA PAKETE LASERSKOG UKLANJANJA DLAČICA',
      body1: 'Platite paket od 7 tretmana unaprijed i ostvarite dodatnih 10% popusta.',
      body2:
        'Ne želite paket? Nakon prvog tretmana nastavite po Loyalty cijeni – 30% nižoj od standardne cijene, uz rezervaciju sljedećeg termina unutar 60 dana.'
    },
    nav: {
      pricing: 'Cijene',
      gallery: 'Galerija',
      faq: 'Pitanja'
    },
    hero: {
      badge: 'MediSpa Skin Clinic · Rijeka',
      titleLine1: 'Lasersko uklanjanje dlačica DEKA Again',
      titleLine2: 'u Rijeci',
      subtitle:
        'Koristimo medicinski laser DEKA Again — tehnologiju u koju vjeruju vodeći europski medicinski centri. Tretmani su brzi, sigurni i praktički bezbolni zahvaljujući naprednom sustavu hlađenja.',
      trustPoints: [
        'Medicinski laser DEKA Again',
        'Praktički bezbolno uz ICE hlađenje',
        'Stručnost pod medicinskim vodstvom'
      ],
      offerEyebrow: 'Ponuda',
      offerTitle: '10% popusta na pakete od 7 tretmana',
      offerBody: 'Ili nastavite po Loyalty cijeni – 30% nižoj od standardne.',
      note: 'Bez obveze · Personalizirani plan tretmana'
    },
    whyChoose: {
      eyebrow: 'Tehnologija',
      titleLine1: 'Zašto odabrati lasersko uklanjanje',
      titleLine2: 'dlačica DEKA Again?',
      intro:
        'DEKA Again nije IPL uređaj ni zastarjeli diodni sustav. Riječ je o vrhunskoj medicinskoj laserskoj platformi osmišljenoj za maksimalnu učinkovitost, sigurnost i udobnost.',
      benefits: [
        {
          title: 'Praktički bezbolni tretmani',
          body: 'Napredna tehnologija hlađenja osigurava udobnost tijekom cijelog tretmana.'
        },
        {
          title: 'Sigurno na osjetljivim područjima',
          body: 'Nježno i učinkovito na osjetljivim zonama.'
        },
        {
          title: 'Učinkovitost za sve tipove kože',
          body: 'Djeluje sigurno na svjetlijim i tamnijim tonovima kože.'
        },
        {
          title: 'Brži tretmani uz manje posjeta',
          body: 'Učinkoviti tretmani koji poštuju vaše vrijeme.'
        },
        {
          title: 'Dugotrajno smanjenje dlačica bez oštećenja kože',
          body: 'Medicinska preciznost cilja folikule dlačica uz punu zaštitu kože.'
        }
      ],
      closingLead:
        'Ista razina tehnologije koja se koristi u profesionalnim medicinskim laserskim klinikama širom svijeta — ',
      closingStrong: 'sada dostupna i u Rijeci.'
    },
    laserDevice: {
      title: 'Laserski sustav DEKA Again Elite',
      introBefore: 'U MediSpa Rijeka koristimo ',
      introStrong: 'DEKA Again Elite',
      introAfter:
        ' — medicinski, vrhunski laserski sustav osmišljen za sigurno, učinkovito i praktički bezbolno uklanjanje dlačica.',
      points: [
        'Napredna aleksandritska laserska tehnologija',
        'Integrirani ICE sustav hlađenja za udobnost',
        'Prikladno za većinu tipova kože',
        'Odobreno od FDA-e i klinički dokazano'
      ],
      imageAlt: 'Laserski uređaj DEKA Again Elite'
    },
    whatHappens: {
      title: 'Što se događa na konzultacijama',
      intro: 'Konzultacije su strukturiran proces osmišljen da vam pruži potpunu jasnoću:',
      items: [
        {
          label: 'Procjena kože i dlačica:',
          text: 'kozmetičar procjenjuje tip vaše kože i karakteristike dlačica kako bi utvrdio prikladnost tretmana.'
        },
        {
          label: 'Medicinska povijest i kontraindikacije:',
          text: 'razgovor o zdravstvenoj povijesti i lijekovima radi sigurnosti laserskog tretmana.'
        },
        {
          label: 'Test na malom području (ako je potrebno):',
          text: 'tretira se manje testno područje kako bi se provjerila moguća reakcija.'
        },
        {
          label: 'Personalizirani plan tretmana:',
          text: 'preporučuje se broj tretmana i razmaci između njih prema vašim potrebama.'
        },
        {
          label: 'Objašnjenje cijena i paketa:',
          text: 'pregled dostupnih paketa i odgovori na pitanja o cijeni.'
        },
        {
          label: 'Vrijeme za pitanja:',
          text: 'klijenti mogu pitati sve o pripremi, njezi nakon tretmana ili očekivanim rezultatima.'
        }
      ],
      outro: 'Konzultacije su besplatne i ne obvezuju vas na ništa.'
    },
    care: {
      title: 'Njega prije i poslije tretmana',
      beforeTitle: 'Prije tretmana',
      beforeItems: [
        'Izbjegavajte sunčanje 2 tjedna',
        'Ne depilirajte voskom i ne čupajte dlačice',
        'Obrijte područje 24 sata prije tretmana',
        'Izbjegavajte proizvode za samotamnjenje'
      ],
      afterTitle: 'Nakon tretmana',
      afterNote: 'Moguća je blaga crvenoća koja se povlači unutar nekoliko sati.',
      afterLead: '48 sati izbjegavajte:',
      afterItems: ['Saunu i teretanu', 'Bazene', 'Izravno sunčevo svjetlo']
    },
    gallery: {
      title: 'Stvarni rezultati',
      subtitle: 'Uvjerite se u transformativne rezultate lasera DEKA Again',
      before: 'Prije',
      after: 'Poslije',
      resultAfter: 'Rezultat nakon',
      beforeAlt: 'prije tretmana',
      afterAlt: 'nakon tretmana',
      prev: 'Prethodna slika',
      next: 'Sljedeća slika',
      goToSlide: 'Idi na slajd',
      disclaimer:
        'Rezultati mogu varirati. Individualni ishodi ovise o tipu dlačice, tonu kože, hormonalnim faktorima i pridržavanju plana tretmana.',
      pairs: [
        { area: 'Bikini linija', treatments: 'samo 1 tretman' },
        { area: 'Cijele noge', treatments: '6 tretmana' },
        { area: 'Pazuha', treatments: '5 tretmana' }
      ]
    },
    testimonials: {
      title: 'Što kažu naši klijenti',
      items: [
        {
          treatment: 'Uklanjanje dlačica',
          text: 'Već nakon prvog tretmana vidljivi su nevjerojatni rezultati… nema više uraslih dlačica, iritacija od stalnog brijanja, a dlačica jednostavno nema. Svima preporučujem MediSpu i Danielu… ugodna atmosfera i profesionalni, sigurni tretmani.'
        },
        {
          treatment: 'Ožiljci od akni',
          text: 'Iskreno preporučujem ovo mjesto! Nakon godina borbe s ožiljcima od akni, MediSpa mi je doslovno promijenila život. Otišla sam na mikroneedling i rezultati su nevjerojatni… već nakon samo dva tretmana ožiljci su minimalni, a koža vidljivo glađa… Daniela je profesionalna i iznimno ljubazna.'
        },
        {
          treatment: 'Uklanjanje tetovaža',
          text: 'Počela sam s laserskim uklanjanjem tetovaže… otkrila sam pravo mjesto za opuštanje… Masaže su fantastične, a Danijela je profesionalna, staložena… osoba s kojom bi poželjeli otići na kavu.'
        },
        {
          treatment: 'Gljivice nokta',
          text: 'Imala sam dugogodišnji problem s gljivicama nokta, ali nakon nekoliko laserskih tretmana u ovom salonu infekcija se značajno povukla, a nokti sada izgledaju zdravo. Iskreno preporučujem.'
        }
      ]
    },
    faq: {
      title: 'Često postavljana pitanja',
      items: [
        {
          question: 'Boli li?',
          answer: 'Ne. Većina klijenata smatra DEKA Again ugodnim zahvaljujući naprednom hlađenju.'
        },
        {
          question: 'Mogu li tretirati preplanulu kožu?',
          answer: 'Da. DEKA tehnologija je sigurnija za veći broj tipova kože od starijih sustava.'
        },
        {
          question: 'Hoće li dlačice ponovno narasti?',
          answer:
            'Laser omogućuje dugotrajno smanjenje dlačica; s vremenom je moguć tek povremeni rast finijih dlačica.'
        },
        {
          question: 'Koliko traje jedan tretman?',
          answer: 'Većina tretmana traje manje od 30 minuta.'
        }
      ],
      outro:
        'Personalizirane odgovore na vaša specifična pitanja dobit ćete tijekom besplatnih konzultacija.'
    },
    pricing: {
      eyebrow: 'Cjenik 2025',
      title: 'Cijene tretmana',
      subtitle:
        'Transparentne cijene uz Loyalty pogodnosti i pakete od 7 tretmana koji donose najbolju vrijednost',
      tabsLabel: 'Kategorije tretmana',
      categories: {
        face: 'Lice',
        intimate: 'Intimne i manje zone',
        body: 'Tijelo'
      },
      columns: {
        treatment: 'Tretman',
        standard: 'Standardna cijena',
        loyalty: 'Loyalty −30%',
        loyalty7: 'Loyalty 7 tretmana',
        prepaid7: 'Paket 7 unaprijed −10%'
      },
      popular: 'Popularno',
      explainerTitle: 'Kako funkcioniraju cijene',
      explainer: [
        { label: 'Standardna cijena', text: '— cijena pojedinačnog tretmana.' },
        {
          label: 'Loyalty −30%',
          text: '— cijena svakog sljedećeg tretmana za klijente koji nastave svoj plan tretmana.'
        },
        {
          label: 'Loyalty 7 tretmana',
          text: '— ukupan iznos za cijeli plan: prvi tretman po standardnoj cijeni, a preostalih šest uz Loyalty popust od 30%.'
        },
        {
          label: 'Paket 7 unaprijed −10%',
          text: '— najbolja vrijednost: paket od 7 tretmana plaćate unaprijed uz dodatnih 10% popusta.'
        }
      ],
      footnote:
        'Konačna cijena potvrđuje se na besplatnim konzultacijama, nakon procjene područja i vašeg plana tretmana.',
      cta: 'Rezerviraj besplatnu konzultaciju'
    },
    safety: {
      title: 'Sigurnost i za koga tretman nije prikladan',
      safeTitle: 'Je li lasersko uklanjanje dlačica sigurno?',
      safeLeadBefore: 'Da. DEKA Again je ',
      safeLeadStrong: 'medicinski sustav',
      safeLeadAfter: ' koji se koristi u klinikama širom svijeta:',
      safeItems: [
        'Kontrolirana isporuka energije',
        'Integrirano hlađenje za zaštitu kože',
        'Sigurno za različite tipove kože'
      ],
      unsuitableTitle: 'Za koga tretman nije prikladan?',
      unsuitableLead: 'Tretman možda nije prikladan ako:',
      unsuitableItems: [
        'Ste trudni/trudnica',
        'Imate određena kožna stanja',
        'Koristite fotosenzibilizirajuće lijekove',
        'Imate aktivne kožne infekcije'
      ],
      unsuitableNote: 'Zato su konzultacije ključne prije tretmana.'
    },
    finalCta: {
      title: 'Započnite besplatnim konzultacijama',
      lead1: 'Nije sigurni je li lasersko uklanjanje dlačica pravo rješenje za vas?',
      lead2: 'Rezervirajte besplatne konzultacije i saznajte:',
      items: [
        'Je li DEKA Again prikladan za vašu kožu',
        'Koliko tretmana vam je potrebno',
        'Koji paket i Loyalty pogodnosti vam donose najbolju vrijednost'
      ],
      note1: 'Online rezervacija traje samo jedan klik.',
      note2: 'Vaš put do glatke, kože bez dlačica počinje ovdje.',
      footnote:
        'Procjenjujemo vašu kožu, objašnjavamo postupak i osmišljavamo vaš personalizirani plan tretmana. Bez pritiska, samo stručni savjet.'
    },
    contact: {
      eyebrow: 'Kontakt',
      title: 'Zatražite besplatne konzultacije',
      subtitle:
        'Ostavite svoje podatke i javljamo vam se u roku od jednog radnog dana kako bismo dogovorili termin koji vam odgovara.',
      nameLabel: 'Ime i prezime',
      namePlaceholder: 'Vaše ime i prezime',
      phoneLabel: 'Telefon',
      phonePlaceholder: 'npr. +385 91 234 5678',
      emailLabel: 'E-mail',
      emailOptional: 'nije obavezno',
      emailPlaceholder: 'vasa.adresa@primjer.com',
      areaLabel: 'Zona koja vas zanima',
      areaPlaceholder: 'Odaberite zonu',
      areaOptions: [
        'Lice / muška brada',
        'Pazuha',
        'Bikini linija / Brazilska',
        'Noge',
        'Ruke',
        'Leđa ili prsa',
        'Više zona',
        'Još ne znam'
      ],
      contactMethodLabel: 'Kako vas kontaktiramo?',
      contactMethods: {
        phone: 'Telefon',
        email: 'E-mail',
        whatsapp: 'WhatsApp'
      },
      messageLabel: 'Poruka',
      messageOptional: 'nije obavezno',
      messagePlaceholder: 'Recite nam nešto više o tome što vas zanima…',
      consentLabel:
        'Pristajem da me MediSpa kontaktira u vezi mojeg upita za konzultacije.',
      submit: 'Pošalji upit',
      submitting: 'Šaljem…',
      privacy: 'Vaše podatke koristimo isključivno za dogovaranje konzultacija.',
      successTitle: 'Hvala vam!',
      successBody:
        'Zaprimili smo vaš upit i javljamo vam se u roku od jednog radnog dana.',
      successAgain: 'Pošalji novi upit',
      errors: {
        name: 'Unesite svoje ime i prezime.',
        phone: 'Unesite ispravan broj telefona.',
        email: 'Unesite ispravnu e-mail adresu.',
        emailRequired: 'Unesite e-mail adresu jer ste odabrali kontakt e-mailom.',
        consent: 'Molimo potvrdite pristanak na kontakt.',
        generic: 'Došlo je do pogreške pri slanju. Pokušajte ponovno ili nas nazovite.'
      }
    }
  },

  en: {
    langLabel: 'English',
    switchTo: 'Prebaci na hrvatski',
    common: {
      bookConsultation: 'Book a free consultation',
      bookAppointment: 'Book a free consultation',
      bookNow: 'Book a free consultation'
    },
    offer: {
      title: '10% OFF LASER HAIR REMOVAL PACKAGES',
      body1: 'Pay for a package of 7 treatments upfront and receive an additional 10% discount.',
      body2:
        "Don't want a package? After your first treatment, continue at our Loyalty Price \u2013 30% below the standard treatment price, provided your next appointment is booked within 60 days."
    },
    nav: {
      pricing: 'Pricing',
      gallery: 'Gallery',
      faq: 'FAQs'
    },
    hero: {
      badge: 'MediSpa Skin Clinic · Rijeka',
      titleLine1: 'DEKA Again Laser Hair Removal',
      titleLine2: 'in Rijeka',
      subtitle:
        'We use the DEKA Again medical laser — the technology trusted by leading European medical centres. Treatments are fast, safe and virtually painless thanks to an advanced cooling system.',
      trustPoints: [
        'DEKA Again medical laser',
        'Virtually painless with ICE cooling',
        'Medically led expertise'
      ],
      offerEyebrow: 'Offer',
      offerTitle: '10% off 7-treatment packages',
      offerBody: 'Or continue at our Loyalty Price – 30% below standard.',
      note: 'No obligation · Personalised treatment plan'
    },
    whyChoose: {
      eyebrow: 'Technology',
      titleLine1: 'Why choose DEKA Again',
      titleLine2: 'laser hair removal?',
      intro:
        'DEKA Again is not an IPL device or an outdated diode system. It is a premium medical laser platform designed for maximum effectiveness, safety and comfort.',
      benefits: [
        {
          title: 'Virtually painless treatments',
          body: 'Advanced cooling technology keeps you comfortable throughout the entire treatment.'
        },
        {
          title: 'Safe on delicate areas',
          body: 'Gentle yet effective on sensitive zones.'
        },
        {
          title: 'Effective for all skin types',
          body: 'Works safely on lighter and darker skin tones.'
        },
        {
          title: 'Faster treatments, fewer visits',
          body: 'Efficient sessions that respect your time.'
        },
        {
          title: 'Long-lasting hair reduction without skin damage',
          body: 'Medical precision targets the hair follicle while fully protecting the skin.'
        }
      ],
      closingLead:
        'The same level of technology used in professional medical laser clinics worldwide — ',
      closingStrong: 'now available in Rijeka.'
    },
    laserDevice: {
      title: 'The DEKA Again Elite laser system',
      introBefore: 'At MediSpa Rijeka we use the ',
      introStrong: 'DEKA Again Elite',
      introAfter:
        ' — a medical-grade, premium laser system designed for safe, effective and virtually painless hair removal.',
      points: [
        'Advanced alexandrite laser technology',
        'Integrated ICE cooling system for comfort',
        'Suitable for most skin types',
        'FDA cleared and clinically proven'
      ],
      imageAlt: 'DEKA Again Elite laser device'
    },
    whatHappens: {
      title: 'What happens during your consultation',
      intro: 'The consultation is a structured process designed to give you complete clarity:',
      items: [
        {
          label: 'Skin and hair assessment:',
          text: 'your therapist assesses your skin type and hair characteristics to confirm suitability.'
        },
        {
          label: 'Medical history and contraindications:',
          text: 'we review your health history and medications to ensure laser treatment is safe.'
        },
        {
          label: 'Patch test (if required):',
          text: 'a small test area is treated to check for any reaction.'
        },
        {
          label: 'Personalised treatment plan:',
          text: 'we recommend the number of sessions and the intervals that suit your needs.'
        },
        {
          label: 'Pricing and packages explained:',
          text: 'an overview of available packages and answers to any cost questions.'
        },
        {
          label: 'Time for questions:',
          text: 'ask anything about preparation, aftercare or the results you can expect.'
        }
      ],
      outro: 'The consultation is free and comes with no obligation.'
    },
    care: {
      title: 'Before and after treatment care',
      beforeTitle: 'Before treatment',
      beforeItems: [
        'Avoid sun exposure for 2 weeks',
        'Do not wax or pluck the hair',
        'Shave the area 24 hours before treatment',
        'Avoid self-tanning products'
      ],
      afterTitle: 'After treatment',
      afterNote: 'Mild redness is possible and usually settles within a few hours.',
      afterLead: 'For 48 hours, avoid:',
      afterItems: ['Sauna and the gym', 'Swimming pools', 'Direct sunlight']
    },
    gallery: {
      title: 'Real results',
      subtitle: 'See the transformative results of the DEKA Again laser',
      before: 'Before',
      after: 'After',
      resultAfter: 'Result after',
      beforeAlt: 'before treatment',
      afterAlt: 'after treatment',
      prev: 'Previous image',
      next: 'Next image',
      goToSlide: 'Go to slide',
      disclaimer:
        'Results may vary. Individual outcomes depend on hair type, skin tone, hormonal factors and adherence to the treatment plan.',
      pairs: [
        { area: 'Bikini line', treatments: 'just 1 treatment' },
        { area: 'Full legs', treatments: '6 treatments' },
        { area: 'Underarms', treatments: '5 treatments' }
      ]
    },
    testimonials: {
      title: 'What our clients say',
      items: [
        {
          treatment: 'Hair removal',
          text: 'Incredible results were visible after the very first treatment… no more ingrown hairs, no irritation from constant shaving, and the hair is simply gone. I recommend MediSpa and Daniela to everyone… a lovely atmosphere and professional, safe treatments.'
        },
        {
          treatment: 'Acne scarring',
          text: 'I honestly recommend this place! After years of struggling with acne scars, MediSpa literally changed my life. I went for microneedling and the results are amazing… after just two treatments the scars are minimal and my skin is visibly smoother… Daniela is professional and extremely kind.'
        },
        {
          treatment: 'Tattoo removal',
          text: 'I started with laser tattoo removal… and discovered the perfect place to relax… The massages are fantastic, and Danijela is professional, calm… the kind of person you would happily go for a coffee with.'
        },
        {
          treatment: 'Nail fungus',
          text: 'I had a long-standing problem with nail fungus, but after several laser treatments at this clinic the infection has receded significantly and my nails now look healthy. I honestly recommend it.'
        }
      ]
    },
    faq: {
      title: 'Frequently asked questions',
      items: [
        {
          question: 'Does it hurt?',
          answer:
            'No. Most clients find DEKA Again comfortable thanks to its advanced cooling system.'
        },
        {
          question: 'Can I treat tanned skin?',
          answer: 'Yes. DEKA technology is safer for a wider range of skin types than older systems.'
        },
        {
          question: 'Will the hair grow back?',
          answer:
            'The laser delivers long-lasting hair reduction; over time only occasional finer regrowth is possible.'
        },
        {
          question: 'How long does one treatment take?',
          answer: 'Most treatments take less than 30 minutes.'
        }
      ],
      outro:
        'You will receive personalised answers to your specific questions during your free consultation.'
    },
    pricing: {
      eyebrow: 'Price list 2025',
      title: 'Treatment pricing',
      subtitle:
        'Transparent pricing with Loyalty benefits and 7-treatment packages that deliver the best value',
      tabsLabel: 'Treatment categories',
      categories: {
        face: 'Face',
        intimate: 'Intimate and smaller areas',
        body: 'Body'
      },
      columns: {
        treatment: 'Treatment',
        standard: 'Standard price',
        loyalty: 'Loyalty −30%',
        loyalty7: 'Loyalty 7 treatments',
        prepaid7: 'Prepaid 7 package −10%'
      },
      popular: 'Popular',
      explainerTitle: 'How the pricing works',
      explainer: [
        { label: 'Standard price', text: '— the price of a single treatment.' },
        {
          label: 'Loyalty −30%',
          text: '— the price of every following treatment for clients continuing their treatment plan.'
        },
        {
          label: 'Loyalty 7 treatments',
          text: '— the total for the full plan: the first treatment at the standard price and the remaining six with the 30% Loyalty discount.'
        },
        {
          label: 'Prepaid 7 package −10%',
          text: '— the best value: pay for the 7-treatment package upfront and receive an additional 10% discount.'
        }
      ],
      footnote:
        'The final price is confirmed at your free consultation, once the area and your treatment plan have been assessed.',
      cta: 'Book a free consultation'
    },
    safety: {
      title: 'Safety and who the treatment is not suitable for',
      safeTitle: 'Is laser hair removal safe?',
      safeLeadBefore: 'Yes. DEKA Again is a ',
      safeLeadStrong: 'medical-grade system',
      safeLeadAfter: ' used in clinics worldwide:',
      safeItems: [
        'Controlled energy delivery',
        'Integrated cooling to protect the skin',
        'Safe for a range of skin types'
      ],
      unsuitableTitle: 'Who is the treatment not suitable for?',
      unsuitableLead: 'The treatment may not be suitable if you:',
      unsuitableItems: [
        'Are pregnant',
        'Have certain skin conditions',
        'Take photosensitising medication',
        'Have active skin infections'
      ],
      unsuitableNote: 'This is exactly why the consultation is essential before treatment.'
    },
    finalCta: {
      title: 'Start with a free consultation',
      lead1: 'Not sure whether laser hair removal is right for you?',
      lead2: 'Book your free consultation and find out:',
      items: [
        'Whether DEKA Again is suitable for your skin',
        'How many treatments you need',
        'Which package and Loyalty benefits give you the best value'
      ],
      note1: 'Booking online takes just one click.',
      note2: 'Your journey to smooth, hair-free skin starts here.',
      footnote:
        'We assess your skin, explain the process and design your personalised treatment plan. No pressure, just expert advice.'
    },
    contact: {
      eyebrow: 'Contact',
      title: 'Request your free consultation',
      subtitle:
        'Leave your details and we will get back to you within one working day to arrange a time that suits you.',
      nameLabel: 'Full name',
      namePlaceholder: 'Your full name',
      phoneLabel: 'Phone',
      phonePlaceholder: 'e.g. +385 91 234 5678',
      emailLabel: 'Email',
      emailOptional: 'optional',
      emailPlaceholder: 'your.address@example.com',
      areaLabel: 'Area you are interested in',
      areaPlaceholder: 'Select an area',
      areaOptions: [
        'Face / male beard',
        'Underarms',
        'Bikini line / Brazilian',
        'Legs',
        'Arms',
        'Back or chest',
        'Multiple areas',
        'Not sure yet'
      ],
      contactMethodLabel: 'How should we contact you?',
      contactMethods: {
        phone: 'Phone',
        email: 'Email',
        whatsapp: 'WhatsApp'
      },
      messageLabel: 'Message',
      messageOptional: 'optional',
      messagePlaceholder: 'Tell us a little more about what you are looking for…',
      consentLabel: 'I agree that MediSpa may contact me about my consultation enquiry.',
      submit: 'Send enquiry',
      submitting: 'Sending…',
      privacy: 'We use your details solely to arrange your consultation.',
      successTitle: 'Thank you!',
      successBody: 'We have received your enquiry and will be in touch within one working day.',
      successAgain: 'Send another enquiry',
      errors: {
        name: 'Please enter your full name.',
        phone: 'Please enter a valid phone number.',
        email: 'Please enter a valid email address.',
        emailRequired: 'Please enter your email address, as you chose email contact.',
        consent: 'Please confirm your consent to be contacted.',
        generic: 'Something went wrong while sending. Please try again or call us.'
      }
    }
  }
} as const

export type TranslationShape = (typeof translations)['hr']
